import * as tslib_1 from "tslib";
import { JsonObject, JsonProperty } from "json2typescript";
let Address = class Address {
    constructor() {
        this.accountId = 0;
        this.addressId = 0;
        this.title = '';
        this.isPrimary = true;
        this.address1 = '';
        this.address2 = '';
        this.address3 = '';
        this.city = '';
        this.state = '';
        this.postalCode = '';
    }
};
tslib_1.__decorate([
    JsonProperty('AccountId', Number, true)
], Address.prototype, "accountId", void 0);
tslib_1.__decorate([
    JsonProperty('AddressId', Number, true)
], Address.prototype, "addressId", void 0);
tslib_1.__decorate([
    JsonProperty('Title', String, true)
], Address.prototype, "title", void 0);
tslib_1.__decorate([
    JsonProperty('IsPrimary', Boolean, true)
], Address.prototype, "isPrimary", void 0);
tslib_1.__decorate([
    JsonProperty('Address1', String, false)
], Address.prototype, "address1", void 0);
tslib_1.__decorate([
    JsonProperty('Address2', String, true)
], Address.prototype, "address2", void 0);
tslib_1.__decorate([
    JsonProperty('Address3', String, true)
], Address.prototype, "address3", void 0);
tslib_1.__decorate([
    JsonProperty('City', String, false)
], Address.prototype, "city", void 0);
tslib_1.__decorate([
    JsonProperty('State', String, false)
], Address.prototype, "state", void 0);
tslib_1.__decorate([
    JsonProperty('PostalCode', String, false)
], Address.prototype, "postalCode", void 0);
Address = tslib_1.__decorate([
    JsonObject
], Address);
export { Address };
